/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Timeline_Useasbaseline2Inputs */

const id_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const ms_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const da_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const de_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const en_us2_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const es_es2_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar como referencia`)
};

const es_mx2_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar como base`)
};

const fil_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const fr_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const it_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const hu_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const nl_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const no_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const pl_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const pt_br2_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const pt_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const ro_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const fi_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const sv_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const vi_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const tr_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const cs_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const bg_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const ru_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использовать как базовый уровень`)
};

const uk_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const ar_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const hi_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बेसलाइन के रूप में इस्तेमाल करें`)
};

const th_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้เป็นฐานเปรียบเทียบ`)
};

const ja_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const zh_cn2_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

const zh_hant1_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設為基準`)
};

const ko_builds_timeline_useasbaseline2 = /** @type {(inputs: Builds_Timeline_Useasbaseline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use as baseline`)
};

/**
* | output |
* | --- |
* | "Use as baseline" |
*
* @param {Builds_Timeline_Useasbaseline2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_timeline_useasbaseline2 = /** @type {((inputs?: Builds_Timeline_Useasbaseline2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Timeline_Useasbaseline2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_timeline_useasbaseline2(inputs)
	if (locale === "ms") return ms_builds_timeline_useasbaseline2(inputs)
	if (locale === "da") return da_builds_timeline_useasbaseline2(inputs)
	if (locale === "de") return de_builds_timeline_useasbaseline2(inputs)
	if (locale === "en-US") return en_us2_builds_timeline_useasbaseline2(inputs)
	if (locale === "es-ES") return es_es2_builds_timeline_useasbaseline2(inputs)
	if (locale === "es-MX") return es_mx2_builds_timeline_useasbaseline2(inputs)
	if (locale === "fil") return fil_builds_timeline_useasbaseline2(inputs)
	if (locale === "fr") return fr_builds_timeline_useasbaseline2(inputs)
	if (locale === "it") return it_builds_timeline_useasbaseline2(inputs)
	if (locale === "hu") return hu_builds_timeline_useasbaseline2(inputs)
	if (locale === "nl") return nl_builds_timeline_useasbaseline2(inputs)
	if (locale === "no") return no_builds_timeline_useasbaseline2(inputs)
	if (locale === "pl") return pl_builds_timeline_useasbaseline2(inputs)
	if (locale === "pt-BR") return pt_br2_builds_timeline_useasbaseline2(inputs)
	if (locale === "pt") return pt_builds_timeline_useasbaseline2(inputs)
	if (locale === "ro") return ro_builds_timeline_useasbaseline2(inputs)
	if (locale === "fi") return fi_builds_timeline_useasbaseline2(inputs)
	if (locale === "sv") return sv_builds_timeline_useasbaseline2(inputs)
	if (locale === "vi") return vi_builds_timeline_useasbaseline2(inputs)
	if (locale === "tr") return tr_builds_timeline_useasbaseline2(inputs)
	if (locale === "cs") return cs_builds_timeline_useasbaseline2(inputs)
	if (locale === "bg") return bg_builds_timeline_useasbaseline2(inputs)
	if (locale === "ru") return ru_builds_timeline_useasbaseline2(inputs)
	if (locale === "uk") return uk_builds_timeline_useasbaseline2(inputs)
	if (locale === "ar") return ar_builds_timeline_useasbaseline2(inputs)
	if (locale === "hi") return hi_builds_timeline_useasbaseline2(inputs)
	if (locale === "th") return th_builds_timeline_useasbaseline2(inputs)
	if (locale === "ja") return ja_builds_timeline_useasbaseline2(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_timeline_useasbaseline2(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_timeline_useasbaseline2(inputs)
	return ko_builds_timeline_useasbaseline2(inputs)
});
export { builds_timeline_useasbaseline2 as "builds.timeline.useAsBaseline" }